document.addEventListener('turbo:load', async () => {
  const showcaseIframe = document.querySelector('#showcase:not(.player)')
  if (showcaseIframe) {
    const data = showcaseIframe.dataset
    if (data.showMpShowcase) {
      showcaseIframe.parentElement.classList.remove('d-none')
      const DPM = new DriftPhotoModule(data.sid, { ...data, ...{ applicationKey: document.querySelector('meta[name="application-key"]').content }})
      await DPM.load()
    }
  }
})
